module.exports = __webpack_public_path__ + "static/media/onlineteacher1.e24ec03b.png";